var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Slowakisch") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-40.6%",
    y: "-40.6%",
    width: "181.2%",
    height: "181.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.16 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M16,8 C16,12.41824 12.4184,16 8,16 C3.58168,16 0,12.41824 0,8 C0,3.58168 3.58168,0 8,0 C12.4184,0 16,3.58168 16,8 L16,8 Z",
    id: "path-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flags-/Slowakai",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-1023",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Clip-1020",
    fill: "#D8D8D8",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Flag_of_Slovakia",
    mask: "url(#mask-3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.100000, -1.500000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EE1C25",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 26,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#0B4EA2",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 26,
    height: 12.375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 0,
    y: 1.125,
    width: 26,
    height: 5.625
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(4.333333, 4.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.42566094,0 L7.18734357,0 L3.79157843,0 L0.395901528,0 L0.157584161,0 L0.13267304,0.255799965 C0.127261415,0.311410033 0,1.65147936 0,4.59446446 C0,5.97719357 0.433106448,7.19709183 1.28731966,8.22022821 C1.88580418,8.93709658 2.66737221,9.54061817 3.67672846,10.0652954 L3.79157843,10.125 L3.90645782,10.0652954 C4.91584348,9.54061817 5.69747033,8.93709658 6.29598427,8.22022821 C7.15019747,7.19709183 7.58333333,5.97719357 7.58333333,4.59446446 C7.58333333,1.6515111 7.45604251,0.311410033 7.45063088,0.255799965 L7.42566094,0 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.79157843,9.80794009 C2.34043948,9.0535857 0.264699038,7.55630367 0.264699038,4.59446446 C0.264699038,1.63262526 0.395901528,0.285668158 0.395901528,0.285668158 L3.79157843,0.285668158 L7.18734357,0.285668158 C7.18734357,0.285668158 7.31860488,1.632657 7.31860488,4.59446446 C7.31860488,7.55630367 5.24283503,9.0535857 3.79157843,9.80794009 L3.79157843,9.80794009 Z",
    id: "Path",
    fill: "#EE1C25",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.10236452,3.81792319 C4.49529553,3.82477922 5.26189336,3.84137972 5.94452277,3.59487984 C5.94452277,3.59487984 5.92649382,3.85851981 5.92649382,4.16558134 C5.92649382,4.47273809 5.94452277,4.73634632 5.94452277,4.73634632 C5.3183919,4.51019236 4.54514718,4.5054947 4.10236452,4.51155722 L4.10236452,6.14745179 L3.48167468,6.14745179 L3.48167468,4.51155722 C3.03889201,4.5054947 2.26567671,4.51019236 1.63951643,4.73634632 C1.63951643,4.73634632 1.65754538,4.47273809 1.65754538,4.16558134 C1.65754538,3.85848807 1.63951643,3.59487984 1.63951643,3.59487984 C2.32214584,3.84137972 3.08874367,3.82477922 3.48167468,3.81792319 L3.48167468,2.79053353 C3.12353688,2.78710551 2.6074914,2.80554698 2.02397708,3.0163066 C2.02397708,3.0163066 2.04200602,2.75269837 2.04200602,2.44554162 C2.04200602,2.13841661 2.02397708,1.87480838 2.02397708,1.87480838 C2.60660907,2.08518711 3.12206633,2.10394598 3.48008649,2.10061319 C3.4616752,1.44998809 3.28606209,0.629993511 3.28606209,0.629993511 C3.28606209,0.629993511 3.64749392,0.66043304 3.79199019,0.66043304 C3.93663351,0.66043304 4.29794769,0.629993511 4.29794769,0.629993511 C4.29794769,0.629993511 4.12239341,1.45001983 4.10395271,2.10054971 C4.46200228,2.10391424 4.97743012,2.08515537 5.56006212,1.8747449 C5.56006212,1.8747449 5.54203317,2.13835313 5.54203317,2.44547814 C5.54203317,2.75263489 5.56006212,3.01624311 5.56006212,3.01624311 C4.97657721,2.80551524 4.46050231,2.78704203 4.10236452,2.79047005 L4.10236452,3.81785971 L4.10236452,3.81792319 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.79119609,5.97027405 C3.06027381,5.97027405 2.66878394,7.06435136 2.66878394,7.06435136 C2.66878394,7.06435136 2.45158367,6.54557798 1.85524615,6.54557798 C1.45175658,6.54557798 1.15441133,6.93284878 0.965386803,7.29148928 C1.69945606,8.55176197 2.87063166,9.32947766 3.79116668,9.80794009 C4.71187817,9.32944592 5.88381845,8.55192068 6.61791712,7.29148928 C6.42889259,6.93284878 6.13154734,6.54557798 5.72805777,6.54557798 C5.13169084,6.54557798 4.91357883,7.06435136 4.91357883,7.06435136 C4.91357883,7.06435136 4.52217719,5.97027405 3.79119609,5.97027405 L3.79119609,5.97027405 Z",
    id: "Path",
    fill: "#0B4EA2",
    fillRule: "nonzero"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSk);
export default __webpack_public_path__ + "static/media/sk.c0b7c5d9a4c268ebeeff1b0230555f9c.svg";
export { ForwardRef as ReactComponent };